
import { connect } from 'react-redux';

import { resetThunk } from '../ArkaneResult/resetThunk';

import Decode from './Decode';

let mapStateToProps = (state, ownProps) => ({
    routeName: state.router.routeName,
    birthDayInput: state.user.birthDayInput,
    birthMonthInput: state.user.birthMonthInput,
    birthYearInput: state.user.birthYearInput,
});

let mapDispatchToProps = (dispatch) => ({
    onDownload: () => {
        //dispatch(updateBirthDay(e.target.value));
    },
    onReset: () => {
        dispatch(resetThunk());
    },
});

const DecodeContainer = connect(mapStateToProps, mapDispatchToProps)(Decode);

export default DecodeContainer;
